import { render, staticRenderFns } from "./DpiEdit.vue?vue&type=template&id=30641138"
import script from "./DpiEdit.vue?vue&type=script&lang=js"
export * from "./DpiEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports